import React from 'react';
import Slide1 from '../assets/images/banner1.png';
import MobileServiceCards from './MobileServiceCards';

const Slider = () => {
    return (
        <>
            <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        {/* Desktop Banner */}
                        <img 
                            className="d-block w-100 d-none d-md-block" 
                            src={Slide1} 
                            alt="Seva Sadhana" 
                        />
                        {/* Mobile Banner */}
                        {/* <img 
                            className="d-block w-100 d-md-none" 
                            src={Slide1Mobile} 
                            alt="Seva Sadhana" 
                        /> */}
                        <div className="carousel-caption">
                            {/* <h5 className='sliderText'>We are here to help<br /> everyone in need</h5> */}
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Mobile Service Cards - Only visible on mobile */}
            <MobileServiceCards />
        </>
    )
}

export default Slider;